import React, { useEffect } from 'react';
import { DraggableComponentProps } from 'features/document/constants';
import { Box, Typography } from '@mui/material';
import { isShipToElement } from 'utils/typeGuards';
import { parseJustifyContentToAlignment } from 'utils/alignmentParsers';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { updateElementById } from 'features/document/documentSlice';
import { selectQuote } from 'features/salesforce/salesforceSlice';

export default function ShipTo({ currentElement }: DraggableComponentProps) {
  if (!isShipToElement(currentElement)) {
    return null;
  }

  const dispatch = useAppDispatch();
  const quote = useAppSelector(selectQuote);

  const { shipTo, address, city, country } = currentElement.content;
  const { justifyContent } = currentElement.style;
  const alignment = parseJustifyContentToAlignment(justifyContent);

  useEffect(() => {
    const { ShippingCity, ShippingCountry, ShippingName, ShippingPostalCode, ShippingState, ShippingStreet } = quote;
    const newShipTo = {
      shipTo: ShippingName,
      address: `${ShippingStreet} ${ShippingCity}`,
      city: `${ShippingPostalCode} ${ShippingState}`,
      country: ShippingCountry,
    };
    dispatch(
      updateElementById({
        elementId: currentElement.id,
        content: newShipTo,
        style: {},
      })
    );
  }, [dispatch, quote]);

  return (
    <Box
      alignItems={justifyContent}
      display={'flex'}
      justifyContent={'center'}
      flexDirection={'column'}
      padding={'8px'}
      width={'100%'}
    >
      <Typography sx={{ textAlign: alignment }} fontSize={'16px'} fontWeight={'500'}>
        Ship To
      </Typography>
      <Typography sx={{ textAlign: alignment }} fontSize={'16px'} flexWrap={'wrap'}>
        {shipTo || 'Name'}
      </Typography>
      <Typography sx={{ textAlign: alignment }} fontSize={'16px'} flexWrap={'wrap'}>
        {address.includes('null') ? 'Address' : address}
      </Typography>
      <Typography sx={{ textAlign: alignment }} fontSize={'16px'} flexWrap={'wrap'}>
        {city.includes('null') ? 'ZIP/Postal Code, City, State' : city}
      </Typography>
      <Typography sx={{ textAlign: alignment }} fontSize={'16px'} flexWrap={'wrap'}>
        {country || 'Country'}
      </Typography>
    </Box>
  );
}
